<template>
  <el-form ref="dataForm" :model="dataForm" :rules="rules" label-width="0px" :disabled="isReadonly" :class="{ readOnlyStyle: isReadonly }" class="dataForm">
    <!-- 财务年度 -->
    <div class="pt10 messageWrap">
      <p class="messageTitle">{{ $t("enroll.establish.yearTitle") }}</p>
      <div class="pt30 flex-row">
        <el-form-item prop="month" ref="month" class="mr40">
          <span class="mr4">{{ $t("enroll.establish.month") }}</span>
          <el-select v-model="dataForm.month" :placeholder="$t('common.placeholder.select')" class="wd140">
            <el-option v-for="nub in 12" :key="'month' + nub" :label="nub" :value="nub"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="date" ref="date">
          <span class="mr4">{{ $t("enroll.establish.date") }}</span>
          <el-select v-model="dataForm.date" :placeholder="$t('common.placeholder.select')" class="wd140">
            <el-option v-for="nub in 31" :key="'date' + nub" :label="nub" :value="nub"></el-option>
          </el-select>
        </el-form-item>
      </div>
    </div>

    <!-- 财务期间 -->
    <div class="pt50 messageWrap">
      <p class="messageTitle">{{ $t("enroll.establish.periodTitle") }}</p>
      <div class="pt30">
        <el-form-item prop="financialYearPeriod" ref="financialYearPeriod">
          <el-select v-model="dataForm.financialYearPeriod" :placeholder="$t('common.placeholder.select')" class="wd400">
            <el-option v-for="item in byCountryFormatList('financialPeriodTypeData')" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
      </div>
    </div>

    <!-- 股本信息 -->
    <div class="pt50 messageWrap">
      <p class="messageTitle">{{ $t("enroll.establish.capitalTitle") }}</p>
      <div class="pt30">
        <el-form-item prop="companyMemberList" ref="companyMemberList">
          <sharehold-information :isReadonly="isReadonly" />
        </el-form-item>
      </div>
    </div>

    <!-- 公司注册地址 -->
    <div class="pt50 pb22 messageWrap">
      <p class="messageTitle">
        {{ $t("enroll.establish.registeredTitle") }}
      </p>
      <div class="pt30">
        <el-form-item prop="registeredOfficeType" ref="registeredOfficeType" class="mb0">
          <el-radio-group v-model="dataForm.registeredOfficeType">
            <div v-if="applymentHasRegisteredAddress">
              <el-radio :label="1">
                <span class="fs14">{{ $t("enroll.establish.regOptionMain") }}</span>
              </el-radio>
            </div>
            <div class="pt12">
              <el-radio :label="2">
                <span class="fs14">{{ $t("enroll.establish.otherMain") }}</span>
                <div class="hg6"></div>
                <span class="fs12 black88 pl20 lh20">{{ $t("enroll.establish.otherTransferMinor") }}</span>
              </el-radio>
            </div>
          </el-radio-group>
          <!-- 采用其他注册地址 -->
          <div class="fs12 pl20 pt14" v-if="dataForm.registeredOfficeType == 2">
            <div class="clearfix errorTipOffset">
              <el-form-item prop="registeredOfficeAddress" ref="registeredOfficeAddress" class="mb20 mr20 fl">
                <span class="fs12 mr4">{{ $t("enroll.establish.address") }}</span>
                <el-input v-model="dataForm.registeredOfficeAddress" :placeholder="$t('common.placeholder.enter')" class="wd300 fs12"></el-input>
              </el-form-item>
              <el-form-item prop="registeredOfficeCity" ref="registeredOfficeCity" class="mb20 mr20 fl">
                <span class="fs12 mr4">{{ $t("enroll.establish.city") }}</span>
                <el-input v-model="dataForm.registeredOfficeCity" :placeholder="$t('common.placeholder.enter')" class="wd300 fs12"></el-input>
              </el-form-item>
              <el-form-item prop="registeredOfficeCountry" ref="registeredOfficeCountry" class="mb20 mr20 fl">
                <span class="fs12 mr4">{{ $t("enroll.establish.country") }}</span>
                <el-select v-model="dataForm.registeredOfficeCountry" :placeholder="$t('common.placeholder.select')" filterable class="wd300">
                  <el-option v-for="item in globalFormatList('countryList')" :key="`registered-${item.value}`" :label="item.label" :value="item.value"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item prop="registeredOfficePostalCode" ref="registeredOfficePostalCode" class="mb20 mr20 fl">
                <span class="fs12 mr4">{{ $t("enroll.establish.code") }}</span>
                <el-input v-model="dataForm.registeredOfficePostalCode" :placeholder="$t('common.placeholder.enter')" class="wd150 fs12"></el-input>
              </el-form-item>
            </div>
          </div>
        </el-form-item>
      </div>
    </div>

    <!-- 工作时长 -->
    <div class="pt50 messageWrap">
      <p class="messageTitle">{{ $t("enroll.establish.hoursTitle") }}</p>
      <div class="pt30">
        <el-form-item prop="workingHours" ref="workingHours">
          <el-radio-group v-model="dataForm.workingHours">
            <div>
              <el-radio label="at least 5">{{ $t("enroll.establish.hoursOption01") }}</el-radio>
            </div>
            <div class="pt12">
              <el-radio label="3 to 5">{{ $t("enroll.establish.hoursOption02") }}</el-radio>
            </div>
          </el-radio-group>
        </el-form-item>
      </div>
    </div>

    <!-- 公司章程 -->
    <div class="pt50 messageWrap">
      <p class="messageTitle">
        {{ $t("enroll.establish.constitutionTitle") }}
      </p>
      <div class="pt30">
        <el-form-item prop="isCustomizedConstitution" ref="isCustomizedConstitution">
          <el-radio-group v-model="dataForm.isCustomizedConstitution">
            <div>
              <el-radio :label="0">{{ $t("enroll.establish.constitutionOption01") }}</el-radio>
            </div>
            <div class="pt12">
              <el-radio :label="1">{{ $t("enroll.establish.constitutionOption02") }}</el-radio>
            </div>
          </el-radio-group>
        </el-form-item>
      </div>
    </div>

    <!-- 行业性质是否特殊、是否已取得相关其他政府机构的批准？ -->
    <div class="pt50 messageWrap">
      <p class="messageTitle">
        {{ $t("enroll.establish.authoritiesTitle") }}
        <el-popover placement="bottom" trigger="hover">
          <div class="linkWrap">
            <p class="fs12">{{ $t("common.reference") }}</p>
            <p class="pt2">
              <a href="https://www.acra.gov.sg/how-to-guides/before-you-start/referral-authorities" target="_blank" class="lh14">
                https://www.acra.gov.sg/how-to-guides/before-you-start/referral-authorities
              </a>
            </p>
          </div>
          <span slot="reference" class="fs16 lucency otn el-icon-question"></span>
        </el-popover>
      </p>
      <div class="pt20">
        <el-form-item class="mb6" prop="hasObtainedApproval" ref="hasObtainedApproval">
          <el-radio-group v-model="dataForm.hasObtainedApproval">
            <el-radio :label="1">{{ $t("common.yes") }}</el-radio>
            <el-radio :label="0">{{ $t("enroll.establish.assist") }}</el-radio>
          </el-radio-group>
          <!-- 选中yes时 -->
          <div class="fs12 pt10 flex-row yesWrap" v-if="dataForm.hasObtainedApproval == 1">
            <el-form-item prop="approvalAuthorities" ref="approvalAuthorities" class="mb0">
              <el-checkbox-group v-model="dataForm.approvalAuthorities" class="clearfix">
                <div v-for="item in byCountryFormatList('governmentData')" :key="`ratify-${item.value}`" class="fl mb12 mupiterSelect">
                  <el-checkbox :label="item.value" class="fxVer">
                    <span class="fs14 preLine">{{ item.label }}</span>
                  </el-checkbox>
                </div>
              </el-checkbox-group>
            </el-form-item>
          </div>
        </el-form-item>
      </div>
    </div>

    <!-- EP签证信息(只有一条信息，用table展示是因为客户的要求) -->
    <div class="pt50 pb22 messageWrap" v-if="applymentHasEPApplication">
      <p class="messageTitle">
        <span>{{ $t("enroll.establish.EPInfo") }}</span>
      </p>
      <div class="pt20">
        <el-form-item prop="epInfo" ref="epInfo">
          <ep-visa-information v-model="dataForm.epInfo" :isReadonly="isReadonly"></ep-visa-information>
        </el-form-item>
      </div>
    </div>
  </el-form>
</template>

<script>
import ShareholdInformation from "../../components/ShareholdInformation";
import EpVisaInformation from "./components/EpVisaInformation";
import { validateLocation, strToNum } from "@/utils/common";
import { mapState, mapGetters } from "vuex";
export default {
  name: "EnrollEstablishSingapore",
  props: {
    isReadonly: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    EpVisaInformation,
    ShareholdInformation,
  },
  data() {
    return {
      dataForm: {
        month: null,
        date: null,
        financialYearPeriod: null,
        companyMemberList: [],
        registeredOfficeType: null,
        registeredOfficeAddress: null,
        registeredOfficeCity: null,
        registeredOfficeCountry: null,
        registeredOfficePostalCode: null,
        workingHours: null,
        isCustomizedConstitution: null,
        hasObtainedApproval: null,
        approvalAuthorities: [],
        epInfo: [],
      },
      rules: {
        month: [
          {
            required: true,
            message: this.$t("common.placeholder.select"),
            trigger: "submit",
          },
        ],
        date: [
          {
            required: true,
            message: this.$t("common.placeholder.select"),
            trigger: "submit",
          },
        ],
        financialYearPeriod: [
          {
            required: true,
            message: this.$t("common.placeholder.select"),
            trigger: "submit",
          },
        ],
        companyMemberList: [
          {
            type: "array",
            required: true,
            message: this.$t("common.placeholder.replenish"),
            trigger: "submit",
          },
        ],
        registeredOfficeType: [
          {
            required: true,
            message: this.$t("common.placeholder.select"),
            trigger: "submit",
          },
        ],
        registeredOfficeAddress: [
          {
            required: true,
            message: this.$t("common.placeholder.enter"),
            trigger: "submit",
          },
        ],
        registeredOfficeCity: [
          {
            required: true,
            message: this.$t("common.placeholder.enter"),
            trigger: "submit",
          },
        ],
        registeredOfficeCountry: [
          {
            required: true,
            message: this.$t("common.placeholder.select"),
            trigger: "submit",
          },
        ],
        registeredOfficePostalCode: [
          {
            required: true,
            message: this.$t("common.placeholder.enter"),
            trigger: "submit",
          },
        ],
        workingHours: [
          {
            required: true,
            message: this.$t("common.placeholder.select"),
            trigger: "submit",
          },
        ],
        isCustomizedConstitution: [
          {
            required: true,
            message: this.$t("common.placeholder.select"),
            trigger: "submit",
          },
        ],
        hasObtainedApproval: [
          {
            required: true,
            message: this.$t("common.placeholder.select"),
            trigger: "submit",
          },
        ],
        approvalAuthorities: [
          {
            type: "array",
            required: true,
            message: this.$t("common.placeholder.select"),
            trigger: "submit",
          },
        ],
        epInfo: [
          {
            type: "array",
            required: true,
            message: this.$t("common.placeholder.replenish"),
            trigger: "submit",
          },
        ],
      },
    };
  },
  computed: {
    ...mapState("applyment", ["applymentDetail", "applymentHasRegisteredAddress", "applymentHasEPApplication"]),
    ...mapGetters("constant", ["globalFormatList", "byCountryFormatList"]),
  },
  methods: {
    // 数据初始化处理
    dataInit() {
      const detail = JSON.parse(JSON.stringify(this.applymentDetail));
      const [month, date] = (detail.financialYearEnd || "").split("/").map(v => Number(v) || null);
      this.dataForm = {
        month,
        date,
        financialYearPeriod: detail.financialYearPeriod,
        companyMemberList: detail.companyMemberList || [],
        registeredOfficeType: detail.registeredOfficeType,
        registeredOfficeAddress: detail.registeredOfficeAddress,
        registeredOfficeCity: detail.registeredOfficeCity,
        registeredOfficeCountry: detail.registeredOfficeCountry,
        registeredOfficePostalCode: detail.registeredOfficePostalCode,
        workingHours: detail.workingHours,
        isCustomizedConstitution: strToNum(detail.isCustomizedConstitution),
        hasObtainedApproval: strToNum(detail.hasObtainedApproval),
        approvalAuthorities: detail.approvalAuthorities || [],
        epInfo: detail.epInfo || [],
      };
    },
    // 获取提交参数(由父级触发)
    getParamsData() {
      return {
        ...this.dataForm,
        financialYearEnd: this.dataForm.month + "/" + this.dataForm.date,
      };
    },
    // 触发必填校验(由父级触发) - 仅下一步时调用
    dataFormSubmit() {
      return new Promise((resolve, reject) => {
        this.$refs["dataForm"].validate((valid, object) => {
          if (valid) {
            resolve();
          } else {
            validateLocation(object, this);
            reject("custom prompt: Form verification failed");
          }
        });
      });
    },
  },
  created() {
    // isReadonly 时，applymentDetail 已存在于 vuex，自行初始化数据
    if (this.isReadonly) {
      this.dataInit();
    }
  },
};
</script>

<style lang="scss" scoped>
.messageTitle {
  border-radius: 2px;
  font-size: 16px;
  line-height: 1em;
  font-weight: 600;
}

.messageTitle:before {
  content: "*";
  margin-right: 4px;
  color: #f56c6c;
}

.yesWrap {
  ::v-deep {
    .el-checkbox__input {
      line-height: 0;
    }
  }
}

.mupiterSelect {
  width: 600px;
  margin-right: 0px;
  padding-right: 30px;
  box-sizing: border-box;
}
</style>
